export const constants = {
    TEST_CONTRACT_ADDRESS: "0x02401839cC507171573A4792F6e11bDDDcF24294"
}